import { ApiFactory, type ApiDataResponse } from '@/utils/api';
import type { latestProgramsI, LatestProgramsReq } from '@/models/interface/listening';

export class ListeningService extends ApiFactory {
  constructor() {
    super('Listen');
  }

  getLatestPrograms(params: LatestProgramsReq): Promise<ApiDataResponse<latestProgramsI>> {
    return this.get('LatestPrograms', params);
  }
}
